/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Title_Earth_DayInputs */

const en_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earth Day Event`)
};

const ar_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فعالية يوم الأرض`)
};

const de_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag der Erde Event`)
};

const es_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento del Día de la Tierra`)
};

const fr_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement du Jour de la Terre`)
};

const it_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento della Giornata della Terra`)
};

const ja_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アースデイイベント`)
};

const ko_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지구의 날 이벤트`)
};

const pt_br_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento do Dia da Terre`)
};

const ru_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятие «День Земли»`)
};

const th_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรมวันคุ้มครองโลก`)
};

const tr_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünya Günü Etkinliği`)
};

const zh_cn_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地球日活动`)
};

const zh_tw_event_title_earth_day = /** @type {(inputs: Event_Title_Earth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地球日活動`)
};

/**
* | output |
* | --- |
* | "Earth Day Event" |
*
* @param {Event_Title_Earth_DayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_title_earth_day = /** @type {((inputs?: Event_Title_Earth_DayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Title_Earth_DayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_title_earth_day(inputs)
	if (locale === "ar") return ar_event_title_earth_day(inputs)
	if (locale === "de") return de_event_title_earth_day(inputs)
	if (locale === "es") return es_event_title_earth_day(inputs)
	if (locale === "fr") return fr_event_title_earth_day(inputs)
	if (locale === "it") return it_event_title_earth_day(inputs)
	if (locale === "ja") return ja_event_title_earth_day(inputs)
	if (locale === "ko") return ko_event_title_earth_day(inputs)
	if (locale === "pt_br") return pt_br_event_title_earth_day(inputs)
	if (locale === "ru") return ru_event_title_earth_day(inputs)
	if (locale === "th") return th_event_title_earth_day(inputs)
	if (locale === "tr") return tr_event_title_earth_day(inputs)
	if (locale === "zh_cn") return zh_cn_event_title_earth_day(inputs)
	return zh_tw_event_title_earth_day(inputs)
});